<template>
  <div>
    <div>
      <h2 class="h1 text-primary mb-20">Авторизация</h2>
      <div class="mb-48">
        <span class="text-muted">Еще не зарегистрированы? </span>
        <router-link :to="{ name: 'signup' }" class="link">Регистрация</router-link>
      </div>
      <el-form
        ref="loginForm"
        :model="form"
        :rules="rules"
        @submit.native.prevent="onLogin">
        <el-form-item label="Логин или e-mail" prop="login" class="mb-32">
          <el-input v-model="form.login" name="login" type="text" />
        </el-form-item>
        <el-form-item label="Пароль" prop="password" class="mb-32">
          <el-input
            v-model="form.password"
            name="password"
            type="password"
            show-password />
        </el-form-item>
        <el-form-item>
          <div class="flex-x-between flex-y-center">
            <el-button
              :loading="$mip('auth')"
              type="primary"
              native-type="submit"
              class="w-half">
              Войти
            </el-button>
            <a class="text-link text-muted cursor-pointer" @click.prevent="passResetDialogVisible = true">Забыли пароль?</a>
          </div>
        </el-form-item>
      </el-form>
    </div>

    <el-dialog
      title="Восстановление пароля"
      :visible.sync="passResetDialogVisible"
      custom-class="el-dialog--small">
      <p class="mb-24">Если Вы забыли пароль, введите ваш email. <br> Вы получите ссылку, перейдя по которой можно указать новый пароль.</p>
      <el-form
        ref="passResetForm"
        :model="passResetForm"
        :rules="passResetRules"
        @submit.native.prevent="onPassReset">
        <el-form-item label="Email" prop="email">
          <el-input v-model="passResetForm.email" size="medium" type="email" />
        </el-form-item>
        <div class="divider" />
        <div class="flex-x-center">
          <el-button
            type="primary"
            size="medium"
            native-type="submit"
            :loading="$mip('resetPassword')">
            Отправить
          </el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import { event } from '@/plugins/event'
  import { mapActions } from 'vuex'

  export default {
    name: 'LoginForm',

    data() {
      return {
        form: {
          login: '',
          password: ''
        },
        error: null,
        rules: {
          login: [
            { required: true, message: 'Пожалуйста, введите логин или E-mail', trigger: 'blur' }
          ],
          password: [
            { required: true, message: 'Пожалуйста, введите пароль', trigger: 'blur' },
            { min: 5, message: 'Пароль должен содержать минимум 5 символов' }
          ]
        },
        passResetDialogVisible: false,
        passResetForm: {
          email: ''
        },
        passResetRules: {
          email: [
            { required: true, message: 'Пожалуйста, введите email', trigger: 'blur' },
            { type: 'email', message: 'Пожалуйста, введите правильный email', trigger: ['blur', 'change'] }
          ]
        }
      }
    },

    methods: {
      onLogin() {
        this.$refs.loginForm.validate((valid) => {
          if (valid) {
            this.$store.dispatch('login', {
              login: this.form.login,
              password: this.form.password
            })
              .then(() => {
                this.redirectTo()
                event.$emit('app:init')
              })
          } else {
            console.error('Error: form validation')
            return false
          }
        })
      },
      onPassReset() {
        this.$refs.passResetForm.validate((valid) => {
          if (valid) {
            this.$store.dispatch('resetPassword', { email: this.passResetForm.email })
              .then(response => {
                this.passResetForm.email = ''
                this.passResetDialogVisible = false
                this.$notify({
                  title: 'Восстановление пароля',
                  message: 'На указанный  email мы отправили пароль для доступа в ваш личный кабинет',
                  type: 'success'
                })
              })
          } else {
            console.error('Error: form validation')
            return false
          }
        })
      },
      redirectTo() {
        const to = this.$route.query.redirectTo || { name: 'home' }
        this.$router.push(to)
      },
      ...mapActions([ 'fetchRoutes', 'setUserData', 'setAccInfo', 'fetchUsers' ])
    }
  }
</script>